import { useState, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/authContext";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button, Loader } from "@mantine/core";
import LogoNavbar from "../../../composents/Logo/NavbarLogo/Logo";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const SetupCardForm = () => {
    const { getToken } = useContext(AuthContext);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirect = searchParams.get("redirect") || "/app/research/list";

    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;

        setLoading(true);
        setError(null);

        const token = getToken();

        try {
            // 1. Obtenir le clientSecret
            const intentRes = await fetch(
                "https://boldee-97d8d36af3bd.herokuapp.com/app/payment/setup-intent",
                {
                    method: "POST",
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            const { clientSecret, error: intentError } = await intentRes.json();
            if (intentError) throw new Error(intentError);

            // 2. Confirmer la carte avec Stripe
            const { setupIntent, error: stripeError } = await stripe.confirmCardSetup(clientSecret, {
                payment_method: { card: elements.getElement(CardElement) }
            });

            if (stripeError) throw new Error(stripeError.message);

            // 3. Sauvegarder le paymentMethod côté backend
            const confirmRes = await fetch(
                "https://boldee-97d8d36af3bd.herokuapp.com/app/payment/setup-intent/confirm",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ paymentMethodId: setupIntent.payment_method })
                }
            );

            const confirmData = await confirmRes.json();
            if (!confirmData.success) throw new Error("Erreur lors de la sauvegarde");

            navigate(redirect);

        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div style={{ border: "1px solid #ccc", borderRadius: 8, padding: 16, marginBottom: 16 }}>
                <CardElement options={{ style: { base: { fontSize: "16px" } } }} />
            </div>
            {error && <p style={{ color: "red", marginBottom: 12 }}>{error}</p>}
            <Button type="submit" fullWidth color="green" disabled={!stripe || loading}>
                {loading ? <Loader size="xs" color="white" /> : "Enregistrer ma carte"}
            </Button>
        </form>
    );
};

const SetupCard = () => {
    return (
        <div className="width95pCenter">
            <LogoNavbar />
            <h3>Moyen de paiement requis</h3>
            <p style={{ color: "#666", marginBottom: 24 }}>
                Ajoutez une carte pour sécuriser les engagements entre entreprises.
                Elle pourra être utilisée conformément à nos conditions en cas d’annulation après confirmation.
                Paiement sécurisé via Stripe.
            </p>
            <Elements stripe={stripePromise}>
                <SetupCardForm />
            </Elements>
        </div>
    );
};

export default SetupCard;
